export const ANDAMENTO_VEICULOS = () => '/andamento-veiculos';
